import * as actions from './actions';
const path = require('path');

const initialState = {
	apis: null,
	loading: false,
	error: false,
	errorDetail: null,
	importDetail: null,
	endpoints: {
		// endpointId : {
		//   loading: <boolean>,
		//   error: false,
		//   errorDetail: null,
		//   endpoint: <endpoint>
		// }
	},
	testapi: {
		// endpointId: {
		//     method: {
		//         executing: <boolean>
		//         error: false,
		//         errorDetail: null,
		//         response: <object>
		//     }
		// }
	},
	apiSpecTypes: {
		error: false,
		errorDetail: null,
		types: null
	},
	deleteSpecError: false
};

function reducefetchGroupSummaries(state) {
	return {
		...state,
		apis: null,
		loading: true,
		error: false,
		testapi: {}
	};
}

function reducefetchGroupSummariesSuccess(state, action) {
	return {
		...state,
		apis: action.payload,
		loading: false,
		error: false
	};
}

function reducefetchGroupSummariesError(state, action) {
	return {
		...state,
		apis: null,
		loading: false,
		error: true,
		errorDetail: action.payload
	};
}

//
// IMPORT_API
//
function importApi(state, action) {
	return {
		...state,
		importDetail: {
			type: action.payload
		}
	};
}

//
// IMPORT_API_CANCEL
//
function importApiCancel(state) {
	return {
		...state,
		importDetail: null
	};
}

//
// Handle VALIDATE_SWAGGER
//
function validateSwagger(state, action) {
	let name;
	const { fileOrUrl, type } = action.payload;
	// TODO: Consider if this logic for name is actually required.
	// If its a url use the base name of the url
	if (typeof fileOrUrl === 'string') {
		const ext = path.extname(fileOrUrl);
		name = path.basename(fileOrUrl, ext);
	} else if (fileOrUrl instanceof Blob) {
		// Use the filename if its a file
		const ext = path.extname(fileOrUrl.name);
		name = path.basename(fileOrUrl.name, ext);
	}
	return {
		...state,
		importDetail: {
			name: name || type,
			type: state.importDetail.type,
			validating: true
		}
	};
}

//
// VALIDATE_SWAGGER_SUCCESS
//
function validateSwaggerSuccess(state, action) {
	const { valid, parsedSpec } = action.payload;
	const { type } = state.importDetail;
	// TODO: seems like something that should happen in the admin API
	// If the swagger is valid but title is an empty string, use the file/url basename
	if (type === 'endpoint' && valid) {
		parsedSpec.info.title = parsedSpec.info.title || state.importDetail.name;
	}
	return {
		...state,
		importDetail: {
			type,
			validating: false,
			error: false,
			errorDetail: null,
			parsedSpec,
			valid
		}
	};
}

//
// VALIDATE_SWAGGER_ERROR
//
function validateSwaggerError(state, action) {
	return {
		...state,
		importDetail: {
			type: state.importDetail.type,
			validating: false,
			error: true,
			errorDetail: action.payload
		}
	};
}

//
// SAVE_ENDPOINT
//
function saveEndpoint(state) {
	return {
		...state,
		loading: true,
		error: false,
		errorDetail: null
	};
}

//
// SAVE_ENDPOINT_SUCCESS
//
function saveEndpointSuccess(state) {
	return {
		...state,
		loading: false,
		error: false,
		errorDetail: null,
		importDetail: null
	};
}

//
// SAVE_ENDPOINT_ERROR
//
function saveEndpointError(state, action) {
	return {
		...state,
		loading: false,
		error: true,
		errorDetail: action.payload
	};
}

function reducefetchEndpoint(state, action) {
	return {
		...state,
		endpoints: {
			...state.endpoints,
			[action.payload.endpointId]: {
				loading: true,
				error: false
			}
		}
	};
}

function reducefetchEndpointSuccess(state, action) {
	return {
		...state,
		endpoints: {
			...state.endpoints,
			[action.payload.endpointId]: {
				loading: false,
				error: false,
				errorDetail: null,
				endpoint: action.payload.endpoint,
				type: action.payload.type,
				name: action.payload.name,
				triggerTypeId: action.payload.triggerTypeId,
				triggeredFlows: action.payload.triggeredFlows,
				invalidTriggers: action.payload.invalidTriggers,
				url: action.payload.url,
				swagger: action.payload.swagger
			}
		}
	};
}

function reducefetchEndpointError(state, action) {
	return {
		...state,
		endpoints: {
			...state.endpoints,
			[action.payload.endpointId]: {
				loading: false,
				error: true,
				errorDetail: action.payload,
				endpoint: null,
				type: null,
				name: null
			}
		}
	};
}

function reduceFetchApiSpecTypesSuccess(state, action) {
	return {
		...state,
		apiSpecTypes: {
			...initialState.apiSpecTypes,
			types: action.payload
		}
	};
}

function reduceFetchApiSpecTypesError(state, action) {
	return {
		...state,
		apiSpecTypes: {
			...initialState.apiSpecTypes,
			error: true,
			errorDetail: action.payload
		}
	};
}

/**
 * fired to show the confirmation modal
 */
function confirmDeleteEndpoint(state, action) {
	return {
		...state,
		endpoints: {
			...state.endpoints,
			[action.payload.endpointId]: {
				...state.endpoints[action.payload.endpointId],
				endpointToDelete: action.payload.endpointToDelete
			}
		}
	};
}

/**
 * fired to send a request to arrow-admin-api to delete
 */
function deleteEndpoint(state, action) {
	return {
		...state,
		endpoints: {
			...state.endpoints,
			[action.payload.endpointId]: {
				...state.endpoints[action.payload.endpointId],
				loading: true,
				error: false
			}
		}
	};
}

/**
 * fired by saga when endpoint deletion was success
 */
function deleteEndpointSuccess(state, action) {
	return {
		...state,
		endpoints: {
			...state.endpoints,
			[action.payload.endpointId]: {
				...state.endpoints[action.payload.endpointId],
				endpointToDelete: null,
				error: false,
				errorDetail: null,
				loading: true
			}
		}
	};
}

/**
 * fired by saga when endpoint delete failed
 */
function deleteEndpointError(state, action) {
	const endpointId = action.payload.source.payload.endpointId;
	return {
		...state,
		endpoints: {
			...state.endpoints,
			[endpointId]: {
				...state.endpoints[endpointId],
				endpointToDelete: null,
				error: true,
				errorDetail: action.payload,
				loading: false
			}
		}
	};
}

function reduceTestAPIEndpoint(state, action) {
	const endpointId = action.payload.endpointId;
	const methodId = action.payload.methodId;
	return {
		...state,
		testapi: {
			...state.testapi,
			[endpointId]: {
				...state.testapi[endpointId],
				[methodId]: {
					executing: true,
					response: null,
					error: false,
					errorDetail: null
				}
			}
		}
	};
}

function reduceTestAPIEndpointCancel(state, action) {
	const endpointId = action.payload.endpointId;
	const methodId = action.payload.methodId;
	return {
		...state,
		testapi: {
			...state.testapi,
			[endpointId]: {
				...state.testapi[endpointId],
				[methodId]: {
					executing: false,
					response: null,
					error: false,
					errorDetail: null
				}
			}
		}
	};
}

function reduceTestAPIEndpointSuccess(state, action) {
	const endpointId = action.payload.endpointId;
	const methodId = action.payload.methodId;
	return {
		...state,
		testapi: {
			...state.testapi,
			[endpointId]: {
				...state.testapi[endpointId],
				[methodId]: {
					executing: false,
					response: action.payload.response,
					error: false,
					errorDetail: null
				}
			}
		}
	};
}

function reduceTestAPIEndpointError(state, action) {
	const endpointId = action.payload.source.payload.endpointId;
	const methodId = action.payload.source.payload.methodId;
	return {
		...state,
		testapi: {
			...state.testapi,
			[endpointId]: {
				...state.testapi[endpointId],
				[methodId]: {
					executing: false,
					error: true,
					errorDetail: action.payload,
					response: null
				}
			}
		}
	};
}

function reduceDeleteComplete(state) {
	return {
		...state,
		deleteSpecError: false
	};
}

function reduceDeleteSpecError(state) {
	return {
		...state,
		deleteSpecError: true
	};
}

export const apidocs = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		case actions.FETCH_GROUP_SUMMARIES:
			return reducefetchGroupSummaries(state);
		case actions.FETCH_GROUP_SUMMARIES_SUCCESS:
			return reducefetchGroupSummariesSuccess(state, action);
		case actions.FETCH_GROUP_SUMMARIES_ERROR:
			return reducefetchGroupSummariesError(state, action);

		case actions.IMPORT_API:
			return importApi(state, action);
		case actions.IMPORT_API_CANCEL:
			return importApiCancel(state);
		case actions.VALIDATE_SWAGGER:
			return validateSwagger(state, action);
		case actions.VALIDATE_SWAGGER_SUCCESS:
			return validateSwaggerSuccess(state, action);
		case actions.VALIDATE_SWAGGER_ERROR:
			return validateSwaggerError(state, action);

		//
		// Endpoints
		//

		case actions.SAVE_ENDPOINT:
			return saveEndpoint(state);
		case actions.SAVE_ENDPOINT_SUCCESS:
			return saveEndpointSuccess(state);
		case actions.SAVE_ENDPOINT_ERROR:
			return saveEndpointError(state, action);

		case actions.FETCH_ENDPOINT:
			return reducefetchEndpoint(state, action);
		case actions.FETCH_ENDPOINT_SUCCESS:
			return reducefetchEndpointSuccess(state, action);
		case actions.FETCH_ENDPOINT_ERROR:
			return reducefetchEndpointError(state, action);
		case actions.DELETE_ENDPOINT_CONFIRM:
			return confirmDeleteEndpoint(state, action);
		case actions.DELETE_ENDPOINT:
			return deleteEndpoint(state, action);
		case actions.DELETE_ENDPOINT_SUCCESS:
			return deleteEndpointSuccess(state, action);
		case actions.DELETE_ENDPOINT_ERROR:
			return deleteEndpointError(state, action);
		//
		// Delete specs
		//
		case actions.DELETE_SPEC_COMPLETE:
			return reduceDeleteComplete(state);
		case actions.DELETE_SPEC_ERROR:
			return reduceDeleteSpecError(state);
		//
		// Test API Endpoint
		//
		case actions.TEST_API_ENDPOINT:
			return reduceTestAPIEndpoint(state, action);
		case actions.TEST_API_ENDPOINT_SUCCESS:
			return reduceTestAPIEndpointSuccess(state, action);
		case actions.TEST_API_ENDPOINT_CANCEL:
		case actions.TEST_API_ENDPOINT_CLEAR:
			return reduceTestAPIEndpointCancel(state, action);
		case actions.TEST_API_ENDPOINT_ERROR:
			return reduceTestAPIEndpointError(state, action);

		case actions.FETCH_API_SPEC_TYPES_SUCCESS:
			return reduceFetchApiSpecTypesSuccess(state, action);
		case actions.FETCH_API_SPEC_TYPES_ERROR:
			return reduceFetchApiSpecTypesError(state, action);

		default:
			return state;
	}
};
